module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.7936/img/iphone-frame.png"